<template>
    <div id="modal-cancel-intv-set" class="modal fade" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="mb-2">
                        <span>
                            取消理由
                        </span>
                        <span>
                            <span class="text-muted">({{this.reasonLength}}/100)</span>
                        </span>
                    </div>
                    <div>
                        <textarea v-model.trim="reason" class="form-control" rows="2" spellcheck=false  maxlength="100"></textarea>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button class="btn btn-danger" type="button" @click="cancelIntv" :disabled="reasonLength == 0">
                        設定する
                    </button>
                    <button class="btn btn-success" type="button" @click="hideThis">
                        &nbsp;&nbsp;閉じる&nbsp;&nbsp;
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        props: {
            opt: String
        },
        data () {
            return {
                item: {},
                // 面接・入場
                reason: "",
            }
        },
        watch: {
            getCancelIntvStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    // 最新のapplyPostを一覧へ反映(面接取消の場合)
                    if (this.opt == '0') {
                        this.$store.dispatch('reflectList', this.getNewApplyPost.data)
                    }
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
                if (status == 3) {
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
            }
        },
        computed: {
            reasonLength () {
                return this.reason.length
            },
            ...mapGetters(['getCancelIntvStatus', 'getNewApplyPost'])
        },
        methods: {
            openThis (item) {
                this.resetThis()
                this.item = item
                this.reason = item.reason ? item.reason : ""
                $('#modal-cancel-intv-set').modal('show')
            },
            hideThis () {
                this.resetThis()
                $('#modal-cancel-intv-set').modal('hide')
            },
            resetThis () {
                this.item = {}
                this.reason = ""
            },
            cancelIntv () {
                this.$store.dispatch("cancelIntv", {
                    postId: this.item.post_id, // 面接画面リフレッシュ用
                    inD: this.item.in_d, // 入場画面リフレッシュ用
                    opt: this.opt,
                    intvId: this.item.id,
                    userId: this.item.user_id,
                    reason: this.reason
                })
            }
        }
    }
</script>

<style>

</style>
